export enum ConditionType {
  Between = 'between',
  BetweenStrict = 'between_strict',
  Equal = 'equal',
  GreaterThan = 'greater_than',
  GreaterThanOrEqual = 'greater_than_or_equal',
  SmallerThan = 'less_than',
  SmallerThanOrEqual = 'less_than_or_equal',
}
